import React from 'react';
import EllipsisTextWithTooltip from '../../../../../../../components/EllipsisTextWithTooltip/EllipsisTextWithTooltip';
import styles from './index.module.scss';

const Result = ({ value, action }) => {
  return (
    <div className={styles.root}>
      <EllipsisTextWithTooltip as="p" className={styles.name}>
        {value}
      </EllipsisTextWithTooltip>

      {action}
    </div>
  );
};

export default Result;
